import axios from "../../axios";

const getDeductionFees = async function (accessToken, params = {}) {
    try {
        const response = await axios.post('/deduction-fees/getDeductionFees', params, {
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getDeductionFees; 
